import { createStore } from "./_createStore";
import type { AppConfigType } from "~/types/appConfig";

type AppConfigState = AppConfigType & {
  setAppConfig: (config: Partial<AppConfigType>) => void;
};

export const useAppConfigStore = createStore<AppConfigState>(
  (set) => ({
    _id: null,
    features: [],
    plans: [],
    setAppConfig: (config) => set(config),
  }),
  "AppConfigStore",
);
